import React from 'react';
import { Link } from 'gatsby';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import menuPaths from '../constants/menuPaths';


import { ReactComponent as BlogLogo } from '../images/svgs/blog-logo.svg';
import msfintImage from '../images/footer/msfint-footer.png';
import euMeditoImage from '../images/footer/euMedito-footer.png';
import flowerImage from '../images/footer/flower-footer.png';
import styles from '../styles/components/footer.module.scss';

const Footer = ({ intl }) => {
  const language = intl.locale;
  const aboutUsPath = `/${language}/${menuPaths.aboutUs[language]}`;
  const contactUsPath = `/${language}/${menuPaths.contactUs[language]}`;
  const contributePath = `/${language}/${menuPaths.contribute[language]}`;
  const legalPath = `/${language}/${menuPaths.legal[language]}`;

  return (
    <footer className={styles.container}>
      <div className={styles.menu}>
        <div className={styles.blogLogoMenu}>
          <BlogLogo />
          <div className={styles.links}>
            <Link to={aboutUsPath}>
              <FormattedMessage id="menu.aboutUs" />
            </Link>
            <Link to={contactUsPath}>
              <FormattedMessage id="menu.contactUs" />
            </Link>
            <Link to={contributePath}>
              <FormattedMessage id="menu.contribute" />
            </Link>
          </div>
        </div>
        <div className={styles.logos}>
          <a
            className={styles.logo}
            href="https://www.manossinfronteras.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="footer.manos.label" />
            <div className={styles.logoImage}>
              <img src={msfintImage} alt="TODO" />
            </div>
          </a>
          <a
            className={styles.logo}
            href="https://www.eumedito.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="footer.yoMedito.label" />
            <div className={styles.logoImage_euMedito}>
              <img src={euMeditoImage} alt="TODO" />
            </div>
          </a>
          <a
            className={styles.logo}
            href="https://www.lajardinera.eu/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="footer.laJardinera.label" />
            <div className={styles.logoImage}>
              <img src={flowerImage} alt="TODO" />
            </div>
          </a>
        </div>
      </div>
      <div className={styles.legal}>
        <Link to={legalPath}>
          <FormattedMessage id="menu.legal" />
        </Link>
        <FormattedMessage id="footer.copyright" />
      </div>
    </footer>
  );
};

Footer.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Footer);
